import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[68px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100"></div>

      <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl"></div>

      <div className="section-container relative w-full">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 lg:gap-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100/80 text-accent-700 rounded-full mb-4">
              {heroData.tag}
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight">
              <span className="text-gradient-gold">{heroData.title}</span>
              <br />
              <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-700">
                {heroData.subtitle}
              </span>
            </h1>

            <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="mt-6 md:mt-8 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-7 md:mt-9 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href={heroData.primaryCta.href}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 hover:border-primary-500/50 text-foreground-600 hover:text-primary-500 font-medium rounded-full text-sm transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line mr-2"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/10 to-primary-500/20 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20film%20reel%20and%20movie%20elements%20collage%2C%20golden%20spotlight%20illuminating%20a%20dark%20theater%20stage%2C%20floating%20film%20strips%20and%20clapperboard%2C%20dramatic%20lighting%20with%20warm%20amber%20and%20deep%20red%20accents%2C%20luxurious%20cinema%20atmosphere%2C%20elegant%20composition%2C%20high%20contrast&width=1000&height=700&seq=hero-main-visual&orientation=landscape"
                alt="无极电影网 - 免费高清影视在线观看平台"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="1000"
                height="700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}